<template>
  <svg :class="svgClass" aria-hidden="true" v-on="$listeners" :style="{opacity:opacity,fill:fill,width:width+'px',height:height+'px'}">
    <use :xlink:href="iconName" x-link:title=""/>
  </svg>
</template>
 
<script>
  export default {
    name: 'SvgIcon',
    props: {
      iconClass: {
        type: String,
        required: true
      },
      className: {
        type: String,
        default: 'home_index'
      },
      opacity:{
        type:Number,
      },
      fill:{
        type:String,
        default:''
      },
      width:{
        type:Number,
        default:14
      },
      height:{
        type:Number,
        default:14
      }
    },
    computed: {
      iconName() {
        return `#icon-${this.iconClass}`
      },
      svgClass() {
        if (this.className) {
          return 'svg-icon ' + this.className
        } else {
          return 'svg-icon'
        }
      }
    }
  }
</script>
 
<style scoped>
  .svg-icon {
    vertical-align: -1px;
    overflow: hidden;
  }
  path:hover {
      display: none;
      opacity: 0;
  }
</style>